import type { ResourceCategory, WebResource } from '@/content/resources';

export type CloudCatalogItem = {
  slug: string;
  name: string;
  title_translations?: Record<string, string>;
  category?: string;
  requires_subscription?: boolean;
  is_new?: boolean;
  published_at?: string | null;
};

export function catalogQueryKey(endpoint: string, mode: string, language: string) {
  return ['catalog', endpoint, mode, language] as const;
}

export function mapCatalogItems(
  items: CloudCatalogItem[],
  category: ResourceCategory,
  routeBase: string,
  language: string,
): WebResource[] {
  return items.map((item) => ({
    slug: item.slug,
    title: item.title_translations?.[language] || item.title_translations?.en || item.name,
    category,
    href: `${routeBase}/${item.slug}`,
    premium: Boolean(item.requires_subscription),
    badgeText: item.is_new ? 'NEW' : null,
    publishedAt: item.published_at ?? null,
  }));
}

/** First list wins identity; any later `premium: true` sticks so cloud flags are not dropped. */
export function mergeWebResources(...lists: Array<readonly WebResource[] | undefined>): WebResource[] {
  const byHref = new Map<string, WebResource>();
  for (const list of lists) {
    for (const item of list ?? []) {
      const existing = byHref.get(item.href);
      if (!existing) {
        byHref.set(item.href, item);
        continue;
      }
      byHref.set(item.href, {
        ...existing,
        premium: Boolean(existing.premium || item.premium),
        ...(item.badgeText && !existing.badgeText ? { badgeText: item.badgeText } : {}),
        ...(item.publishedAt && !existing.publishedAt ? { publishedAt: item.publishedAt } : {}),
      });
    }
  }
  return [...byHref.values()];
}
